import RankBrain2StickyNavbar from 'RankBrain2StickyNavbar';
import TaxStickyBar from 'TaxStickyBar';
import RankBrain2SidebarLanding from 'RankBrain2SidebarLanding';
import RankBrain2EditorialDownloadSection from 'RankBrain2EditorialDownloadSection';
import RankBrain3LandingDownloadSection from 'RankBrain3LandingDownloadSection';


window.RankBrain2StickyNavbar = RankBrain2StickyNavbar;
window.TaxStickyBar = TaxStickyBar;
window.RankBrain2SidebarLanding = RankBrain2SidebarLanding;
window.RankBrain2EditorialDownloadSection = RankBrain2EditorialDownloadSection;
window.RankBrain3LandingDownloadSection = RankBrain3LandingDownloadSection;



// WEBPACK FOOTER //
// ./src-assets/js/rank-brain-2.js